/**
 * Features:
 * - §14.4.5 humidor illustration: tall cabinet humidor with glazed door, shelf
 *   lines and a hygrometer — used in the collection snapshot and empty states.
 */
import {
  ILLUSTRATION_ACCENT,
  PortalIllustration,
  type PortalIllustrationProps,
} from './portal-illustration';

type Props = Omit<PortalIllustrationProps, 'viewBox' | 'children'>;

export function HumidorCabinetIllustration(props: Props) {
  return (
    <PortalIllustration viewBox="0 0 96 120" {...props}>
      {/* cabinet body */}
      <path d="M22 10h52v100H22z" />
      <path d="M18 110h60" />
      {/* glazed door */}
      <rect x="28" y="18" width="40" height="72" rx="1" />
      {/* shelves with cigar rows */}
      <path d="M28 40h40M28 62h40" />
      <path d="M33 34h8M45 34h8M57 34h8" />
      <path d="M33 56h8M45 56h8M57 56h8" />
      <path d="M33 78h8M45 78h8M57 78h8" />
      {/* hygrometer + pull */}
      <circle cx="48" cy="27" r="4" stroke={ILLUSTRATION_ACCENT} />
      <path d="M72 50v8" stroke={ILLUSTRATION_ACCENT} />
      {/* plinth drawers */}
      <path d="M22 98h52M35 104h10M51 104h10" />
    </PortalIllustration>
  );
}
